// @flow strict
import { CMSSections } from './constants'
import { BLOCKS } from '@contentful/rich-text-types'
import { getNodeType } from './richTextGetters'

export const indexName = '__MONZO_INDEX__'
export const subtitleNodeName = '__MONZO_SUBTITLE_NODE__'

const isEmbeddedEntry = node => node.nodeType === BLOCKS.EMBEDDED_ENTRY
let subtitleIndexOffset = 0

/* 
We want some information about the order of the components which Contentful doesn't
easily proide so we essentially decorate the Contentful payload with some extra 
information to help us decide on how to render something. (ie Is it an even or odd row?)

One example is to know when to alternate between gray and white backgrounds. Or know 
how to alternate Text and Image columns so they're not all the same side. 

We don't count Subtitle sections because they should be part of the component they title.05

We also don't include Bespoke components in the count since they should get to determine their own 
background, direction, and everything.

*/
const addIndecesToContentSections = (existingPayloadEntry, index, entries) => {
  if (!isEmbeddedEntry(existingPayloadEntry)) {
    return existingPayloadEntry
  }

  const isFirstSection = index === 0

  const isAfterASkippedSection =
    index > 1 &&
    [CMSSections.SUBTITLE, CMSSections.BESPOKE].includes(
      getNodeType(entries[index - 1]),
    )

  if (isFirstSection) {
    subtitleIndexOffset = 0
  }
  if (isAfterASkippedSection) {
    subtitleIndexOffset += 1
  }
  // Only decorate with a prev entry if it's a section title so that it can live within that <section> (but not bloat the document)
  const hasPreviousSubtitleEntry =
    !isFirstSection &&
    isAfterASkippedSection &&
    getNodeType(entries[index - 1]) === CMSSections.SUBTITLE

  return {
    [indexName]: index - subtitleIndexOffset,
    [subtitleNodeName]: hasPreviousSubtitleEntry
      ? entries[index - 1]
      : undefined,
    ...existingPayloadEntry,
  }
}

export const withDecoratedNodes = (data: {
  // $FlowIgnoreMe - We don't currently type Contentful API shapes
  +content: ?{ content: Array<any> },
}) => {
  return (
    data &&
    data.content && {
      ...data.content,
      // Annoyingly, this *is* what thet contentful payload is shaped like
      // $FlowIgnoreMe - We don't currently type Contentful API shapes
      content: data.content.content.map<any>(addIndecesToContentSections),
    }
  )
}
